import Immutable from 'immutable';
import * as Sentry from '@sentry/nextjs';
import { UPDATE_CONTINUE_WATCHING_ITEMS } from '../actions/continueWatching/actions';
import { createDeepEqualSelector } from '../utils/redux';

// Match last part with continueWatching action
const CONTINUE_WATCHING = 'continueWatching';
const CONTINUE_WATCHING_ACTIVE = 'active';
const CONTINUE_WATCHING_ITEMS = 'items';

const getItems = (state) => state.getIn([CONTINUE_WATCHING, CONTINUE_WATCHING_ITEMS], Immutable.List());
const getFilterDeleted = (state, filterDeleted) => filterDeleted;

export const continueWatchingActiveSelector = (state) =>
    state.getIn([CONTINUE_WATCHING, CONTINUE_WATCHING_ACTIVE], true);

export const continueWatchingItemsSelector = createDeepEqualSelector([getItems, getFilterDeleted], (items) =>
    items.filter((item) => {
        const videoId = item.get('videoId');

        // Trying to debug an error caught by Sentry where video ID was undefined
        if (typeof videoId === 'undefined') {
            const scope = new Sentry.Scope();
            scope.setExtra('continue_watching_item', item.toJS());
            Sentry.captureMessage('Missing video ID in contiue watching', () => scope);

            return false;
        }

        return true;
    })
);
export const continueWatchingPositionForVideo = (state, videoId) => {
    if (continueWatchingActiveSelector(state) === false) {
        return 0;
    }

    const items = continueWatchingItemsSelector(state);

    const item = items.find((i) => i.get('videoId') === videoId);

    return item && !item.get('ended') ? item.get('position') : 0;
};

const initialState = Immutable.fromJS({
    active: true,
    items: [],
});

export default function continueWatching(state = initialState, action = '') {
    switch (action.type) {
        case UPDATE_CONTINUE_WATCHING_ITEMS: {
            let newState = state.getIn([]);
            // eslint-disable-next-line no-restricted-syntax
            for (const key of Object.keys(action.payload)) {
                newState = newState.set(key, Immutable.fromJS(action.payload[key]));
            }

            return state.setIn([], newState);
        }
        default:
            return state;
    }
}
